export const list = ['Home', 'About', 'Projects', 'Experience', 'Contact'];
